export const AdMarketplaceSlotDivNames = {
    slot1: 'admarketplace-slot1',
    slot2: 'admarketplace-slot2',
    slot3: 'admarketplace-slot3',
    slot4: 'admarketplace-slot4',
    textAdContainer: 'admarketplace-text-ads',
    productAdContainer: 'admarketplace-product-ads',
} as const;

export type AdMarketplaceSlotDivName = typeof AdMarketplaceSlotDivNames[keyof typeof AdMarketplaceSlotDivNames];

export const AdMarketplaceSlotContainerNames = {
    slot1Container: 'admarketplace-slot1-container',
    slot2Container: 'admarketplace-slot2-container',
    slot3Container: 'admarketplace-slot3-container',
    slot4Container: 'admarketplace-slot4-container',
    textAdContainer: 'admarketplace-text-ads-container',
    productAdContainer: 'admarketplace-product-ads-container',
};

export const getContainerNameBySlotId = (slotId: string) => {
    const slotMap: Record<string, string> = {
        [AdMarketplaceSlotDivNames.slot1]: AdMarketplaceSlotContainerNames.slot1Container,
        [AdMarketplaceSlotDivNames.slot2]: AdMarketplaceSlotContainerNames.slot2Container,
        [AdMarketplaceSlotDivNames.slot3]: AdMarketplaceSlotContainerNames.slot3Container,
        [AdMarketplaceSlotDivNames.slot4]: AdMarketplaceSlotContainerNames.slot4Container,
    };
    
    return slotMap[slotId] || undefined;
};


